// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

// The tagged union or sum type for the algebraic type `TacticsBoardPreset`.
const TacticsBoardPreset = __t.enum("TacticsBoardPreset", {Small: __t.unit(),
  Medium: __t.unit(),
  Large: __t.unit(),
});

export default TacticsBoardPreset;


